module.exports = __webpack_public_path__ + "media/effects-2.a13eb02d.webm";